module.exports = __webpack_public_path__ + "static/media/gifdesligando.4a71b0ad.gif";